import * as XLSX from 'xlsx';
import { parseDynamicLabel, getDimensionName } from './analyticsUtils';

export const exportToExcel = async (
  getAllData,
  executedTimeFrame,
  executedDimension,
  selectedTableInfo,
  selectedTable,
  setIsExporting
) => {
  setIsExporting(true);
  try {
    const allData = await getAllData();
    
    if (!allData || allData.length === 0) {
      alert('No hay datos para exportar');
      return;
    }

    const processedData = [];
    
    if (executedTimeFrame > 0) {
      // Para datos con marco temporal
      allData.forEach(timeFrameGroup => {
        if (timeFrameGroup.results && Array.isArray(timeFrameGroup.results)) {
          timeFrameGroup.results.forEach(result => {
            const row = {
              'Marco Temporal': timeFrameGroup.timeFrame
            };
            
            const parsedLabel = parseDynamicLabel(result.label);
            const dynamicColumns = Object.keys(parsedLabel);
            
            if (dynamicColumns.length > 0) {
              dynamicColumns.forEach(column => {
                row[column] = parsedLabel[column] || '-';
              });
            } else {
              const dimensionName = getDimensionName(executedDimension);
              row[dimensionName] = result.label || 'Sin etiqueta';
            }
            
            row['Pedidos'] = result.count || 0;
            row['Suma'] = result.sum || 0;
            row['Promedio'] = result.average || 0;
            
            if (executedDimension === 4) {
              row['Productos Total'] = result.quantityCount || 0;
              row['Productos Promedio'] = result.quantityAverage || 0;
            }
            
            processedData.push(row);
          });
        }
      });
    } else {
      // Para datos sin marco temporal
      allData.forEach(result => {
        const row = {};
        
        const parsedLabel = parseDynamicLabel(result.label);
        const dynamicColumns = Object.keys(parsedLabel);
        
        if (dynamicColumns.length > 0) {
          dynamicColumns.forEach(column => {
            row[column] = parsedLabel[column] || '-';
          });
        } else {
          const dimensionName = getDimensionName(executedDimension);
          row[dimensionName] = result.label || 'Sin etiqueta';
        }
        
        row['Pedidos'] = result.count || 0;
        row['Suma'] = result.sum || 0;
        row['Promedio'] = result.average || 0;
        
        if (executedDimension === 4) {
          row['Productos Total'] = result.quantityCount || 0;
          row['Productos Promedio'] = result.quantityAverage || 0;
        }
        
        processedData.push(row);
      });
    }

    // Crear el libro de Excel
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(processedData);
    
    // Ajustar el ancho de las columnas
    const colWidths = [];
    if (processedData.length > 0) {
      Object.keys(processedData[0]).forEach(key => {
        const maxLength = Math.max(
          key.length,
          ...processedData.map(row => String(row[key] || '').length)
        );
        colWidths.push({ wch: Math.min(maxLength + 2, 50) });
      });
    }
    ws['!cols'] = colWidths;
    
    XLSX.utils.book_append_sheet(wb, ws, 'Analytics');
    
    // Generar nombre del archivo
    const tableName = selectedTableInfo?.displayName || selectedTable;
    const dateStr = new Date().toISOString().split('T')[0];
    const fileName = `Analytics_${tableName}_${dateStr}.xlsx`;
    
    // Descargar el archivo
    XLSX.writeFile(wb, fileName);
    
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    alert('Error al exportar los datos: ' + error.message);
  } finally {
    setIsExporting(false);
  }
};